import { Label } from "@/ui/base/label";
import { cn } from "@/nucleo/utilitarios";

interface FormFieldWrapperProps {
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
  trailing?: React.ReactNode;
}

export function FormFieldWrapper({
  label,
  required,
  error,
  hint,
  children,
  className,
  htmlFor,
  trailing,
}: FormFieldWrapperProps) {
  return (
    <div className={cn("space-y-1.5", className)}>
      <div className="flex items-center justify-between">
        <Label
          htmlFor={htmlFor}
          className={cn(
            "text-xs font-semibold uppercase tracking-wider text-muted-foreground",
            error && "text-destructive-text",
          )}
        >
          {label}
          {required && <span className="text-destructive-text ml-0.5">*</span>}
        </Label>
        {trailing}
      </div>
      {children}
      {error && (
        <p className="text-xs text-destructive-text font-medium animate-in slide-in-from-top-1 duration-200" role="alert">
          {error}
        </p>
      )}
      {hint && !error && (
        <p className="text-[11px] text-muted-foreground">{hint}</p>
      )}
    </div>
  );
}
